import { ConcurrentCare } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

type GetConcurrentCareArgs = {
  patientId: string | null
}

const concurrentCareApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConcurrentCare: builder.query<ConcurrentCare[], GetConcurrentCareArgs>({
      query: ({ patientId }) => ({
        method: 'get',
        url: `/lt/v1/patient/${patientId}/concurrentCare`,
      }),
      providesTags: [RTKQueryTag.CONCURRENT_CARE],
    }),
  }),
})

export const { useGetConcurrentCareQuery } = concurrentCareApi
export default concurrentCareApi
